// Lightweight cookie-consent + Google Consent Mode v2 helpers.
// GA4/GTM IDs are placeholders until the client provides them.

export const CONSENT_KEY = "mc_cookie_consent_v1";

export type ConsentValue = "granted" | "denied";
export type ConsentState = {
  analytics: ConsentValue;
  ads: ConsentValue;
  decided_at: string;
};

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export function getConsent(): ConsentState | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    return raw ? (JSON.parse(raw) as ConsentState) : null;
  } catch {
    return null;
  }
}

export function saveConsent(state: ConsentState) {
  localStorage.setItem(CONSENT_KEY, JSON.stringify(state));
  applyConsent(state);
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent("mc-consent-updated", { detail: state })
    );
  }
}

export function initConsentMode() {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer!.push(arguments);
  };
  // Default: deny until the user decides (GDPR / Ley 21.719 aligned)
  window.gtag("consent", "default", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
    functionality_storage: "granted",
    security_storage: "granted",
    wait_for_update: 500,
  });
  const saved = getConsent();
  if (saved) applyConsent(saved);
}

export function applyConsent(state: ConsentState) {
  if (typeof window === "undefined" || !window.gtag) return;
  window.gtag("consent", "update", {
    ad_storage: state.ads,
    ad_user_data: state.ads,
    ad_personalization: state.ads,
    analytics_storage: state.analytics,
  });
}
